export default {
      id: "oc-icon_vnc-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_vnc",
      toString: function () {
        return this.url;
      }
    }